<template>
  <v-container fluid style="height:100%">
    <iframe
      v-if="dashboardUrl"
      :src="dashboardUrl"
      frameborder="0"
      width="100%"
      height="100%"
      allowtransparency
    ></iframe>
    <v-slide-y-transition v-else mode="out-in">
      <v-layout column align-center>
        <img src="@/assets/logo.png" alt="Vuetify.js" class="mb-5">
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  export default {

    created () {
      this.$store.commit('UPDATE_TITLE', 'Gritus Client Dashboard')
    },

    computed: {
      dashboardUrl () {
        return this.$store.state.dashboardUrl
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue